import { Item, Picker, Text } from "@adobe/react-spectrum";
import { useControls, useControlSetter } from "./Main";
import { randomizeArray } from "../utils";

const fonts = [
  "Arial",
  "Georgia",
  "Merriweather",
  "OpenSans",
  "Poppins",
  "Roboto",
  "SourceSerifPro",
  "Times",
];
interface fontHeight {
  data: Record<string, number>;
}

export const fontHeightDict: fontHeight = {
  data: {
    Poppins: 8.926,
    Arial: 8.499,
    OpenSans: 8.73,
    Roboto: 8.621,
    Merriweather: 9.131,
    Georgia: 7.947,
    SourceSerifPro: 7.846,
    Times: 7.406,
  },
};

const rand_fonts = randomizeArray(fonts);

export function FontPicker() {
  const controls = useControls();
  const controlSetter = useControlSetter();
  const fontItems = rand_fonts.map((item) => (
    <Item key={item}>
      <Text UNSAFE_style={{ fontFamily: item }}>{item}</Text>
    </Item>
  ));
  return (
    <Picker
      label="Font name"
      selectedKey={controls.fontName}
      onSelectionChange={(val) => {
        controlSetter("fontName", "picker", val);
        // update font size with normalization
        controlSetter(
          "fontSize",
          "normalization",
          (((17 * fontHeightDict.data["Times"]) / 16) * 16) /
            fontHeightDict.data[val]
        );
      }}
      labelPosition="side"
      width={250}
    >
      {fontItems}
    </Picker>
  );
}
